import Vue from 'vue'
import VueGtm from 'vue-gtm'
import VueI18n from 'vue-i18n'
import VTooltip from 'v-tooltip'
import VeeValidate, { Validator } from 'vee-validate'
import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import { Vue as VueIntegration } from '@sentry/integrations'

import hu from 'vee-validate/dist/locale/hu'
import { sync } from 'vuex-router-sync'
import 'normalize.css'

import { version } from '../package.json'
import { createHttp } from './services'
import { router } from './router'
import store from './store'

import attributes from './locales/hu/attributes'
import customMessages from './locales/hu/custom-messages'
import { password } from './validators/password'
import itSkills from './validators/it-skills'

import Datepicker from './components/Datepicker.vue'
import ErrorNotice from './components/ErrorNotice.vue'
import RatingStars from './components/Ratings/RatingStars.vue'

import CustomFileInput from './directives/custom-file-input'
import Loading from './directives/loading'
import Sticky from './directives/sticky'
import StickyNavbar from './directives/sticky-navbar'

import AgeFilter from './filters/age'
import CurrencyFilter from './filters/currency'
import DateFilter from './filters/date'
import DistanceInWordsFilter from './filters/distance-in-words'
import ExperienceFilter from './filters/experience'
import WeekRange from './filters/week-range'
import YesNoFilter from './filters/yes-no'

import App from './App.vue'

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.ENVIRONMENT,
  release: version,
  integrations: [
    new Integrations.BrowserTracing(),
    new VueIntegration({ Vue, attachProps: true })
  ],
  tracesSampleRate: 0.3
})

Vue.use(VueI18n)

// Add locale helper.
hu.messages._default = field => `A megadott ${field} hibás.`
Validator.localize('hu', hu)

// Install the plugin and set the locale.
Vue.use(VeeValidate, {
  locale: 'hu',
  events: 'blur',
  dictionary: {
    hu: {
      attributes,
      ...customMessages
    }
  }
})
Validator.extend('password', password)
Validator.extend('itSkills', itSkills)

Vue.component('Datepicker', Datepicker)
Vue.component('ErrorNotice', ErrorNotice)
Vue.component('RatingStars', RatingStars)

Vue.directive('custom-file-input', CustomFileInput)
Vue.directive('loading', Loading)
Vue.directive('sticky', Sticky)
Vue.directive('sticky-navbar', StickyNavbar)

Vue.filter('age', AgeFilter)
Vue.filter('currency', CurrencyFilter)
Vue.filter('date', DateFilter)
Vue.filter('distanceInWords', DistanceInWordsFilter)
Vue.filter('experience', ExperienceFilter)
Vue.filter('weekRange', WeekRange)
Vue.filter('yesNo', YesNoFilter)

Vue.config.productionTip = false

createHttp()

// sync the router with the vuex store.
// this registers `store.state.route`
sync(store, router)

Vue.use(VueGtm, { vueRouter: router })
Vue.use(VTooltip)

export const i18n = new VueI18n({ locale: 'hu' })
import('./locales/hu/index').then(locale => i18n.setLocaleMessage('hu', locale.default))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js